export const ADD_DOCUMENT_TYPE = "ADD_DOCUMENT_TYPE";
export const DELETE_DOCUMENT_TYPE = "DELETE_DOCUMENT_TYPE";